/* =================== SLIDE NOTÍCIAS =================== */
jQuery(document).ready(function ($) {
  const dots = $(".noticias-slide .bl-noticia-in").length > 1;
  $(".noticias-slide").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: dots,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  });
});
